import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PageContainer from '../../components/Layout/PageContainer';
import PageHeader from '../../components/Layout/PageHeader';
import { MainApi } from '../../utils/MainApi';

import './Events.css';

const STATUS_LABELS = {
  Draft: 'Черновик',
  Approved: 'Согласовано',
  Preparation: 'Подготовка',
  Scheduled: 'Запланировано',
  Completed: 'Завершено',
  Cancelled: 'Отменено',
};

const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  const [y, m, d] = dateStr.split('-');
  return `${d}.${m}.${y}`;
};

const trimTime = (t) => (t ? String(t).slice(0, 5) : null);

const EventDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await MainApi.getOneEvent(id);
        setEvent(res);
      } catch (err) {
        console.error(err);
        setError('Не удалось загрузить данные события');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  if (loading) {
    return (
      <PageContainer maxWidth="800px">
        <div className="event-details__loader">
          <div className="proto-loader"></div>
          <p style={{ marginTop: '16px', color: '#666' }}>Загрузка данных события...</p>
        </div>
      </PageContainer>
    );
  }

  if (error || !event) {
    return (
      <PageContainer maxWidth="800px">
        <div className="event-details__error">
          <h3>Ошибка</h3>
          <p>{error || 'Событие не найдено'}</p>
          <button className="proto-btn proto-btn-secondary" onClick={() => navigate('/events')}>Вернуться к списку</button>
        </div>
      </PageContainer>
    );
  }

  const startTime = trimTime(event.startTime);
  const endTime = trimTime(event.endTime);
  const timeRange = startTime
    ? (endTime ? `${startTime} — ${endTime}` : startTime)
    : null;

  return (
    <PageContainer maxWidth="800px">
      <PageHeader
        title={event.title}
        subtitle="Детали мероприятия"
      />

      <div style={{ marginTop: '1.5rem' }}>
        {/* Основные данные */}
        <div className="event-details__card">
          <h3 className="event-details__card-title">Основная информация</h3>
          <div className="event-details__grid">
            {/* <div className="event-details__field">
              <span className="event-details__label">Статус</span>
              <span className="event-details__value">
                <span className={`events-status-badge events-status-badge--${event.status}`}>
                  {STATUS_LABELS[event.status] || event.status}
                </span>
              </span>
            </div> */}

            <div className="event-details__field">
              <span className="event-details__label">Контрагент</span>
              <span className="event-details__value">
                {event.Contractor?.companyName || (
                  <span className="event-details__empty">—</span>
                )}
              </span>
            </div>

            <div className="event-details__field">
              <span className="event-details__label">Дата события</span>
              <span className="event-details__value">{formatDate(event.eventDate)}</span>
            </div>

            <div className="event-details__field">
              <span className="event-details__label">Время</span>
              <span className="event-details__value">
                {timeRange || <span className="event-details__empty">—</span>}
              </span>
            </div>

            <div className="event-details__field">
              <span className="event-details__label">Место проведения</span>
              <span className="event-details__value">
                {event.eventPlace || <span className="event-details__empty">—</span>}
              </span>
            </div>

            <div className="event-details__field">
              <span className="event-details__label">Количество гостей</span>
              <span className="event-details__value">
                {event.countOfPerson || <span className="event-details__empty">—</span>}
              </span>
            </div>
          </div>
        </div>

        {/* Заметки */}
        <div className="event-details__card">
          <h3 className="event-details__card-title">Заметки</h3>
          <div className="event-details__notes">
            {event.notes ? (
              <p className="event-details__notes-text">{event.notes}</p>
            ) : (
              <p className="event-details__notes-placeholder">Нет дополнительных заметок.</p>
            )}
          </div>
        </div>

        {/* Связанные КП */}
        <div className="event-details__card">
          <h3 className="event-details__card-title">Связанные КП</h3>
          <div className="event-details__kps">
            {event.kps && event.kps.length > 0 ? (
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {event.kps.map(kp => (
                  <li 
                    key={kp.id} 
                    className="event-details__kp-item"
                    onClick={() => navigate(`/kp/${kp.kpNumber}`)}
                  >
                    <div style={{ fontWeight: '500' }}>
                      <a
                        href={`/kp/${kp.kpNumber}`}
                        onClick={(e) => { e.preventDefault(); }}
                        style={{ color: '#0070fb', textDecoration: 'none' }}
                      >
                        КП № {kp.kpNumber}
                      </a>
                    </div>
                    {kp.listTitle && <div style={{ fontSize: '0.9rem', color: '#666' }}>{kp.listTitle}</div>}
                    <div style={{ fontSize: '0.85rem', color: '#999' }}>Дата КП: {formatDate(kp.kpDate)}</div>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="event-details__notes-placeholder">Нет связанных коммерческих предложений.</p>
            )}
          </div>
        </div>
      </div>

      <div style={{ height: '80px' }} />

      <div className="proto-sticky-bar">
        <div className="proto-sticky-content">
          <button className="proto-btn proto-btn-primary" onClick={() => navigate(`/events/${id}/edit`)}>
            Изменить мероприятие
          </button>
        </div>
      </div>
    </PageContainer>
  );
};

export default EventDetails;
